module.exports = __webpack_public_path__ + "img/students2_new.ee8fee2e.png";